import { useCore } from '@/composables/core/index.js'

import { useLogger } from '@booksy-com/vue-tools'

const logger = useLogger('router.guard.login-required')

export default function (route, from, next) {
  logger.debug(route.path)

  const r = route.matched.find(r => r.meta.loginRequired)

  const { store } = useCore()
  if (r && !store.state.identity.accessToken) {
    logger.debug('redirecting to "login" view...')
    next({ name: 'onboarding' })
  } else {
    next()
  }
}
